import { render, staticRenderFns } from "./PropHeadline.vue?vue&type=template&id=3f3b9a14&scoped=true"
import script from "./PropHeadline.vue?vue&type=script&lang=js"
export * from "./PropHeadline.vue?vue&type=script&lang=js"
import style0 from "./PropHeadline.vue?vue&type=style&index=0&id=3f3b9a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b9a14",
  null
  
)

export default component.exports